import React, { useState } from "react";
import moment from "moment";

import { TextBadge, useDeleteConfirmation } from "../common";

import { NXDelete, NXEditPen, NXEyes } from "../../icons";

import useApi from "../../api";

import PromoCodeDetails from "./promoCodeDetails";
import GenericSelectableTable from "../selectableTable";
import { toast } from "react-toastify";

function PromoCodesTable({ promocodes, fetchPromoCodes, setEdit, setOpenModal }: {promocodes:any; fetchPromoCodes: ()=>void; setEdit: React.Dispatch<any>; setOpenModal: React.Dispatch<any>}) {
  const [openPromoDetails, setOpenPromoDetails] = useState(null);
  const api = useApi()

  const handleEdit = (promocode: any) => {
    setEdit(promocode)
    setOpenModal(true)
  };

  const {handleDelete} = useDeleteConfirmation()

  const columns = [
    {
      header: "Order", key: "id", render: (item: any)=>(
        <div className="py-4">
          <p>{item.code}</p>
          <p className="text-sm font-normal text-base-300 mt-1">#ID{item.id}</p>
        </div>
      )
    },
    {
      header: "Code type", key: "code_type"
    },
    {
      header: "Value", key: "value"
    },
    {
      header: "Activate Status", key: "activate_status", render: (item: any) => (
        <TextBadge value={item.activate_status} label={item.is_active ? "active" : "inactive"} />
      )
    },
    {
      header: "Expiration Date", key: "expiration_date", render: (item: any) => (
        item.expiration_date ? moment(item.expiration_date).format("MMMM D, YYYY") : "No Expire"
      )
    },
    {
      header: "Redemption Limit", key: "redemption_limit"
    },
    {
      header: "Total Redemption", key: "total_redemptions"
    },
    {
      header: "Action", key: "", render: (item:any)=>(
        <div className="flex gap-2 items-center">
          <button
            className="text-primary-500 hover:underline"
            onClick={(e) => {
              e.preventDefault();
              setOpenPromoDetails(item.id);
            }}
          >
            <NXEyes />
          </button>
          <button className="text-primary-500 hover:underline" onClick={() => handleEdit(item)}>
            <NXEditPen />
          </button>
          <button className="text-red-500 hover:underline" onClick={() =>{
            handleDelete(
              item.id,
              "Promo Code",
              api.deletePromocode,
              fetchPromoCodes
            )
          }}>
            <NXDelete />
          </button>
        </div>
      )
    },
  ]

  const bullkActionButtons = [
    {
      label: 'Delete Selected',
      onClick: (selectedItems:any) => {
        toast.success(`Delete items: ${Array.from(selectedItems)}`);
        // Implement delete logic here
      },
    },
    {
      label: 'Export Selected',
      onClick: (selectedItems:any) => {
        toast.success(`Export items: ${Array.from(selectedItems)}`);
        // Implement export logic here
      },
    },
  ];


  return (
    <div className="relative overflow-x-auto">
      <GenericSelectableTable columns={columns} data={promocodes} bullkActionButtons={bullkActionButtons}/>

      {
        openPromoDetails && (
          <PromoCodeDetails
            isOpen={openPromoDetails ? true : false}
            id={openPromoDetails}
            onClose={() => setOpenPromoDetails(null)}
          />
        )
      }
      
    </div>
  );
}

export default PromoCodesTable;
